/**
 * Les prochaines activités, pour le pied de page.
 *
 * ## Ce que ça remplace
 *
 * La colonne « Stages » du pied de page listait cinq catégories inventées à la
 * maquette — Nature, Cirque, Science, Multisport, Cuisine — pointant vers
 * `/activities?category=…`. Trois défauts en un : la catégorie n'existe dans
 * aucune table, `/activities` est derrière la connexion, et le paramètre est
 * ignoré. Un visiteur non connecté y trouvait un mur de login ; un assistant
 * qui suivait ces liens depuis la page d'accueil n'y trouvait rien du tout.
 *
 * ## Une seule lecture, partagée
 *
 * Le pied de page est rendu sur CHAQUE page. Une requête par rendu serait
 * absurde pour une liste qui change quelques fois par an : la promesse est
 * donc mémorisée, et toutes les pages d'une même visite se la partagent.
 *
 * La mémorisation porte sur la promesse et non sur son résultat, pour que deux
 * composants montés en même temps n'en déclenchent pas deux. En cas d'échec,
 * elle est oubliée — sans quoi une panne réseau d'une seconde condamnerait le
 * pied de page pour toute la visite.
 */

import { grouperParActivite, type Activite } from './catalogue';
import { stagesPublics } from './gateway.supabase';

let enCours: Promise<Activite[]> | null = null;

/** Le nombre d'entrées du pied de page : de quoi donner envie, pas un catalogue. */
export const COMBIEN_AU_PIED = 5;

export function oublierLesProchainesActivites(): void {
  enCours = null;
}

/**
 * Les prochaines activités distinctes, la plus proche d'abord.
 *
 * Distinctes : « Les Aigles » occupe dix séances du programme d'automne, et
 * les lister toutes remplirait le pied de page d'une seule activité. C'est
 * `grouperParActivite` qui les rassemble, et sa vitrine — la séance la plus
 * précoce — qui donne l'adresse du lien.
 */
export async function prochainesActivites(): Promise<Activite[]> {
  if (!enCours) {
    enCours = stagesPublics()
      .then((stages) =>
        grouperParActivite(stages)
          .slice()
          .sort((a, b) => a.vitrine.start_date.localeCompare(b.vitrine.start_date))
          .slice(0, COMBIEN_AU_PIED),
      )
      .catch((e) => {
        enCours = null;
        throw e;
      });
  }
  return enCours;
}
